/* Ryan LP subscription cart adds.
 * Shopify cart permalinks don't honor selling_plan, so CTA links of the form
 * /cart/<variant>:<qty>?selling_plan=<plan> are posted to /cart/add.js instead,
 * then the page goes to /cart. 3-bag adds also add the gift variant from the
 * link's data-gift-variant (the $10 gift card), matching the gamified tier
 * selector. Same pattern as sections/lp-timeline.liquid.
 * Loaded by each ryan-lp CTA section; the guard keeps one listener.
 */
(function () {
  'use strict';
  if (window.__rlpCartAdd) return;
  window.__rlpCartAdd = true;

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || !link.closest('.rlp')) return;
    var m = link.getAttribute('href').match(/^\/cart\/(\d+):(\d+)\?selling_plan=(\d+)/);
    if (!m) return;
    e.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    link.setAttribute('aria-disabled', 'true');
    var qty = parseInt(m[2], 10);
    var items = [{ id: parseInt(m[1], 10), quantity: qty, selling_plan: parseInt(m[3], 10) }];
    var giftVariantId = parseInt(link.getAttribute('data-gift-variant'), 10) || 0;
    if (qty === 3 && giftVariantId) { items.push({ id: giftVariantId, quantity: 1 }); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).finally(function () { link.removeAttribute('aria-disabled'); window.location = '/cart'; });
  });

  /* A page restored from the back/forward cache keeps the busy flag; clear it. */
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) {
      document.querySelectorAll('.rlp a[aria-disabled="true"]').forEach(function (a) { a.removeAttribute('aria-disabled'); });
    }
  });
})();
